module.exports = __webpack_public_path__ + "src/img/artist/artist03.jpg?3d0376136dc77d5440689b53ad2694fc";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist03.jpg
// module id = 110
// module chunks = 0